import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['menu', 'frame', 'unit', 'input', 'ids']

  search() {
    this.typed = this.typedAtCaret()
    if (this.typed) {
      this.unitTargets.forEach((unit) => { unit.hidden = !unit.textContent.toLowerCase().includes(this.typed.query.toLowerCase()) })
      this.highlight(this.visibleUnits()[0])
    }

    this.menuTarget.hidden = !this.typed || (this.frameTarget.hasAttribute('complete') && this.unitTargets.every((unit) => unit.hidden))
  }

  navigate(event) {
    if (this.menuTarget.hidden) return

    const units = this.visibleUnits()
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault()
      const step = event.key === 'ArrowDown' ? 1 : -1
      this.highlight(units[(units.indexOf(this.activeUnit) + step + units.length) % units.length])
    } else if (event.key === 'Enter' && this.activeUnit) {
      event.preventDefault()
      event.stopImmediatePropagation()
      this.activeUnit.querySelector('button').click()
    } else if (event.key === 'Escape') {
      this.menuTarget.hidden = true
    }
  }

  pick({ params: { id, name } }) {
    const { node, start, end } = this.typed
    const rest = node.splitText(end)
    node.textContent = node.textContent.slice(0, start)

    const mention = document.createElement('span')
    mention.contentEditable = 'false'
    mention.className = 'text-indigo-600 font-medium'
    mention.dataset.unitId = id
    mention.textContent = `@${name}`
    const space = document.createTextNode(' ')
    rest.before(mention, space)

    this.inputTarget.focus()
    window.getSelection().collapse(space, 1)
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
  }

  removeMention(event) {
    const mention = event.key === 'Backspace' && this.mentionBeforeCaret()
    if (!mention) return

    event.preventDefault()
    mention.remove()
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
  }

  syncIds() {
    this.idsTarget.replaceChildren(...[...this.inputTarget.querySelectorAll('[data-unit-id]')].map((mention) => {
      const field = document.createElement('input')
      field.type = 'hidden'
      field.name = 'message[unit_ids][]'
      field.value = mention.dataset.unitId
      return field
    }))
  }

  close(event) {
    if (!this.element.contains(event.target)) this.menuTarget.hidden = true
  }

  highlight(unit) {
    this.activeUnit = unit
    this.unitTargets.forEach((other) => other.querySelector('button').setAttribute('aria-selected', other === unit))
    unit?.scrollIntoView({ block: 'nearest' })
  }

  visibleUnits() {
    return this.unitTargets.filter((unit) => !unit.hidden)
  }

  mentionBeforeCaret() {
    const { anchorNode, anchorOffset } = window.getSelection()
    if (anchorNode?.parentElement?.dataset.unitId) return anchorNode.parentElement

    const before = anchorNode?.nodeType === Node.TEXT_NODE ? anchorOffset === 0 && anchorNode.previousSibling : anchorNode?.childNodes[anchorOffset - 1]

    return before?.dataset?.unitId ? before : null
  }

  typedAtCaret() {
    const { anchorNode, anchorOffset } = window.getSelection()
    if (anchorNode?.nodeType !== Node.TEXT_NODE || !this.inputTarget.contains(anchorNode)) return null

    const match = anchorNode.textContent.slice(0, anchorOffset).match(/@([^@]*)$/)
    return match && { node: anchorNode, start: match.index, end: anchorOffset, query: match[1] }
  }
}
